module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/regression/regression.component.css
// module id = ./src/app/regression/regression.component.css
// module chunks = main